module.exports = __webpack_public_path__ + "img/qfz.22dc7266.png";